module.exports = __webpack_public_path__ + "static/media/point-marker-dummy.25b252cb.svg";